var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollapseDiagonalLine = function SvgCollapseDiagonalLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 5.333h-1.667v5.834h5.834V9.5h-2.989l3.578-3.577-1.179-1.179L15 8.322zM5.833 14.5h2.989l-3.578 3.577 1.179 1.179L10 15.678v2.989h1.667v-5.834H5.833z"
  })));
};
export default SvgCollapseDiagonalLine;